import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/HowToSelectSMPSHero-bg.webp";
import ArticleImg        from "../../asset/images/news/article-21.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .hts { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO ══ */
  .hts-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden; 
  }
  .hts-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right; display: block;
  }
  .hts-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .hts-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .hts-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px; max-width: 520px;
  }
  .hts-hero-divider {
    width: 479px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .hts-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .hts-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .hts-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .hts-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .hts-bc-item:hover { color: #EB2019; }
  .hts-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .hts-bc-sep img { width: 24px; height: 24px; display: block; }
  .hts-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER ══ */
  .hts-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ MAIN ══ */
  .hts-main-section { padding: 80px 0 120px 0; }
  .hts-main-row { display: flex; align-items: flex-start; gap: 89px; }

  /* ══ ARTICLE ══ */
  .hts-article { flex: 1; min-width: 0; }

  .hts-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .hts-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A; padding-right: 15px;
  }
  .hts-meta-item:last-child { border-right: none; padding-right: 0; }
  .hts-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  .hts-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 30px;
  }

  .hts-article-img {
    width: 100%; height: 450px;
    object-fit: cover; border-radius: 10px;
    display: block; margin: 45px 0 30px 0;
  }

  .hts-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .hts-article-body p { margin-bottom: 20px; }
  .hts-article-body p:last-child { margin-bottom: 0; }

  .hts-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 5px 0 15px 0; line-height: 160%; display: block;
  }

  /* Bullet list */
  .hts-article-body ul {
    list-style: none; margin: 0 0 30px 0; padding: 0;
    display: flex; flex-direction: column; gap: 15px;
  }
  .hts-article-body ul li {
    display: flex; align-items: flex-start; gap: 10px;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .hts-article-body ul li::before {
    content: '•'; color: #202020;
    font-size: 16px; line-height: 160%; flex-shrink: 0;
  }
  .hts-article-body ul li > span { flex: 1; }

  .hts-article-body strong { font-weight: 600; color: #202020; }

  .hts-red-link { color: #EB2019; text-decoration: underline; font-weight: 600; }
  .hts-red-link:hover { opacity: 0.8; }

  /* ══ BOTTOM ROW ══ */
  .hts-bottom-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7; flex-wrap: wrap; gap: 16px;
  }
  .hts-bottom-nav { display: flex; align-items: center; gap: 60px; }
  .hts-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .hts-nav-btn:hover { color: #EB2019; }
  .hts-nav-btn img { width: 40px; height: 40px; display: block; }

  .hts-share-icons { display: flex; align-items: center; gap: 20px; }
  .hts-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0; transition: opacity 0.15s;
  }
  .hts-share-icon:hover { opacity: 0.85; }
  .hts-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .hts-sidebar { flex: 0 0 475px; }
  .hts-sidebar-block { margin-bottom: 60px; }
  .hts-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }
  .hts-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .hts-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .hts-recent-item:hover .hts-recent-title { color: #EB2019; }
  .hts-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .hts-recent-body { flex: 1; min-width: 0; }
  .hts-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }
  .hts-social-icons { display: flex; align-items: center; gap: 30px; }
  .hts-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .hts-social-icon:hover { opacity: 0.8; }
  .hts-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .hts-hero             { height: 350px; }
    .hts-hero-content     { padding: 0 32px; }
    .hts-hero-title       { font-size: 30px; }
    .hts-hero-divider     { width: 100%; max-width: 479px; }
    .hts-breadcrumb       { padding: 24px 0 0 0; }
    .hts-breadcrumb-inner { padding: 0 32px; }
    .hts-inner            { padding: 0 32px; }
    .hts-main-section     { padding: 48px 0 60px 0; }
    .hts-main-row         { flex-direction: column; gap: 48px; }
    .hts-sidebar          { flex: none; width: 100%; }
    .hts-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .hts-hero             { height: 360px; }
    .hts-hero-content     { padding: 0 16px; }
    .hts-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .hts-hero-divider     { width: 100%; }
    .hts-hero-subtitle    { font-size: 14px; }
    .hts-breadcrumb       { padding: 30px 0 0 0; }
    .hts-breadcrumb-inner { padding: 0 16px; }
    .hts-bc-item          { font-size: 14px; gap: 14px; }
    .hts-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .hts-bc-sep img       { width: 22px; height: 22px; }
    .hts-inner            { padding: 0 16px; }
    .hts-main-section     { padding: 30px 0 60px 0; }
    .hts-main-row         { flex-direction: column; gap: 60px; }
    .hts-sidebar          { flex: none; width: 100%; }
    .hts-article-title    { font-size: 20px; margin-bottom: 15px; }
    .hts-article-body     { font-size: 14px; }
    .hts-article-body p   { margin-bottom: 15px; }
    .hts-article-body ul li { font-size: 14px; }
    .hts-meta-item        { font-size: 14px; }
    .hts-article-img      { margin: 30px 0 15px 0; height: 250px; }
    .hts-h2               { font-size: 16px; margin: 30px 0 15px 0; }
    .hts-nav-btn img      { width: 24px; height: 24px; }
    .hts-nav-btn          { font-size: 14px; }
    .hts-share-icon img   { width: 34px; height: 34px; }
    .hts-article-body ul { margin: 0 0 20px 0;     gap: 10px;}
    .hts-sidebar-title { font-size: 20px; }
  }
`;

const recentPosts = [
   {
       img: RecentImg1,
       title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
       slug: "battery-formation-testing-enabling-the-rise-of-ev-energy-storage-manufacturing/",
     },
     {
       img: RecentImg2,
       title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
       slug: "next-gen-esp-power-supplies-upgrades-and-sustainability-in-industrial-air-pollution-control/",
     },
     {
       img: RecentImg3,
       title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
       slug: "green-hydrogen-power-electronics-ador-powertron-at-the-forefront-of-electrolyzer-rectifier-setups/",
     },
     {
       img: RecentImg4,
       title: "Transformer Bushings: Types & Importance",
       slug: "transformer-bushings-guide/",
     },

];

export default function HowToSelectRightSMPS() {
  return (
    <div className="hts">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="hts-hero">
        <img className="hts-hero-bg" src={HeroBgImg} alt="How To Select Right SMPS Hero" />
        <div className="hts-hero-overlay" />
        <div className="hts-hero-content">
          <h1 className="hts-hero-title">
            How to Select the Right SMPS for Your Power Requirements?
          </h1>
          <hr className="hts-hero-divider" />
          <p className="hts-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="hts-breadcrumb" aria-label="Breadcrumb">
        <div className="hts-breadcrumb-inner">
          <a href="/" className="hts-bc-item">Home</a>
          <span className="hts-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="hts-bc-item">News &amp; Updates</a>
          <span className="hts-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="hts-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="hts-main-section">
        <div className="hts-inner">
          <div className="hts-main-row">

            {/* ── ARTICLE ── */}
            <article className="hts-article">

              {/* Meta bar */}
              <div className="hts-meta-bar">
                <span className="hts-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="hts-meta-item"><img src={CalendarIcon} alt="date" /> April 28, 2025</span>
                <span className="hts-meta-item"><img src={ClockIconImg} alt="time" /> 6:50 am</span>
                <span className="hts-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="hts-article-title">
                How to Select the Right SMPS for Your Power Requirements?
              </h1>

              {/* Body */}
              <div className="hts-article-body">

                <p>SMPS stands for Switched-Mode Power Supply, a type of electronic power supply that uses switching regulators to efficiently convert electrical power. Unlike traditional linear power supplies, SMPS rapidly switches on and off to control and stabilize the output voltage, which results in higher efficiency and reduced heat generation. It is widely used in devices such as computers, televisions, battery chargers, and industrial equipment due to its compact size, lightweight design, and ability to handle a wide range of input voltages. SMPS can convert power from AC to DC, DC to DC, or even DC to AC depending on the configuration.</p>

                <p>Whether you are designing an industrial control system or setting up a new piece of electronic equipment, choosing the right SMPS (Switched Mode Power Supply) is critical. Pick the wrong one, and you risk performance issues, overheating, or even damaging your device. But get it right? You will enjoy seamless efficiency, safety, and longevity.</p>

                <p>In this blog, we will break down the five essential factors to consider when selecting the perfect SMPS for your power requirements. From understanding your load to checking for protection features, we will help you make an informed, confident choice that keeps your systems running smoothly.</p>

                {/* Article image */}
                <img className="hts-article-img" src={ArticleImg} alt="SMPS Power Supply Selection" />

                <p>Let's get started.</p>

                <span className="hts-h2">1. Know Your Load Requirements</span>

                <p>Before you even think about browsing SMPS models, lock in your load needs.</p>

                <ul>
                  <li><span>How much power (in watts) will your system consume?</span></li>
                  <li><span>Are you powering a resistive, inductive, or capacitive load?</span></li>
                  <li><span>Will the load be constant or variable?</span></li>
                </ul>

                <p>The <strong>SMPS</strong> you choose must comfortably handle your system's maximum load. Always account for peak conditions—not just the average. It's a good idea to add a 20–30% buffer for safety. For example, if your device consumes 100W, opt for an SMPS rated for at least 120–130W. This ensures you're never stretching your power supply to its limit, which can lead to a shorter lifespan and reduced efficiency.</p>

                <span className="hts-h2">2. Decide Between Constant Voltage vs. Constant Current</span>

                <p>Not all SMPS units are built the same. Some are designed to deliver a constant voltage, while others provide a constant current.</p>

                <ul>
                  <li><span>Use constant voltage SMPS for applications like powering microcontrollers, LEDs (with resistors), or electronic gadgets.</span></li>
                  <li><span>Use constant current SMPS for applications like high-power LEDs or battery charging systems where the current needs to be regulated precisely.</span></li>
                </ul>

                <p>Understanding what your equipment needs—voltage stability or current stability—will help you make the right choice from the start.</p>

                <span className="hts-h2">3. Check Input Voltage Range Compatibility</span>

                <p>Let's face it, power sources aren't always consistent—especially in industrial or remote environments.</p>

                <p>That's why choosing an SMPS with a wide input voltage range is a smart move. It allows your device to run safely even if there are fluctuations in the supply (a common issue in areas with unstable grids).</p>

                <p>For example, an SMPS that operates within the 85–265V AC range can handle most global power standards without breaking a sweat. It's all about flexibility and future proofing.</p>

                <span className="hts-h2">4. Look at the Efficiency Rating</span>

                <p>You wouldn't run a car that wastes half its fuel—so why use an SMPS that wastes energy?</p>

                <p>Efficiency is a major player here. Look for <strong>high-efficiency SMPS units</strong>—ideally 85% or higher. Higher efficiency means:</p>

                <ul>
                  <li><span>Less energy waste</span></li>
                  <li><span>Lower heat generation</span></li>
                  <li><span>Reduced cooling costs</span></li>
                  <li><span>Longer lifespan</span></li>
                </ul>

                <p>Ador's high-efficiency SMPS solutions are built with cutting-edge technology to ensure you get the most out of every watt, without unnecessary losses or heating issues.</p>

                <span className="hts-h2">5. Don't Ignore Protection Features</span>

                <p>Let's be bold: skipping protection features is like riding a bike downhill with no brakes.</p>

                <p>The right <strong>SMPS</strong> should come with built-in protection such as:</p>

                <ul>
                  <li><span>Overvoltage Protection (OVP)</span></li>
                  <li><span>Overcurrent Protection (OCP)</span></li>
                  <li><span>Short Circuit Protection (SCP)</span></li>
                  <li><span>Thermal Shutdown</span></li>
                </ul>

                <p>These aren't just add-ons—they're essentials. They shield both your power supply and the connected load from accidental damage. For mission-critical or sensitive applications, these safety features are non-negotiable.</p>

                <span className="hts-h2">Conclusion</span>

                <p>Choosing the right SMPS might seem technical, but with the right partner, it becomes a strategic advantage.</p>

                <p>At <a href="/" className="hts-red-link">Ador</a> , we don't just provide power supplies—we power your possibilities. Our wide range of SMPS units are designed for durability, efficiency, and superior protection. Whether you're in industrial automation, telecommunications, or LED lighting, we've got a tailor-made solution to keep your operations running smoothly.</p>

                <span className="hts-h2">Ready to make the right power move?</span>

                <p><a href="/contact-us" className="hts-red-link">Connect with Ador today</a> to explore our SMPS solutions and discover how we can energise your business with reliable, smart power.</p>

              </div>

              {/* ── Bottom row ── */}
              <div className="hts-bottom-row">
                <div className="hts-bottom-nav">
                  <a href="/news/how-to-choose-transformer-bushing-high-voltage" className="hts-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/how-medium-frequency-power-switching-transforming-industry" className="hts-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="hts-share-icons">
                  <a href="https://www.facebook.com/sharer.php?u=https://adorpowertron.com/select-right-smps-power-requirements/" className="hts-share-icon" aria-label="Facebook" target="blank">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="https://x.com/i/jf/onboarding/web?redirect_after_login=%2Fintent%2Ftweet%3Ftext%3D%2520https%3A%2F%2Fadorpowertron.com%2Fselect-right-smps-power-requirements%2F&mode=login" className="hts-share-icon" aria-label="Twitter" target="blank">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="https://www.linkedin.com/login/?session_redirect=https%3A%2F%2Fwww.linkedin.com%2FshareArticle%3Fmini%3Dtrue%26url%3Dhttps%3A%2F%2Fadorpowertron.com%2Fselect-right-smps-power-requirements%2F%26title%3DWhat%2520is%2520SMPS%253F%2520%257C%2520SMPS%2520Explained%2520%2526%2520Applications%26summary%3D%26source%3Dhttps%3A%2F%2Fadorpowertron.com%2Fselect-right-smps-power-requirements%2F" className="hts-share-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="hts-sidebar">

              {/* Recent Posts */}
              <div className="hts-sidebar-block">
                <p className="hts-sidebar-title">Recent Posts</p>
                <div className="hts-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="hts-recent-item">
                      <img src={post.img} alt={post.title} className="hts-recent-img" />
                      <div className="hts-recent-body">
                        <span className="hts-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="hts-sidebar-block">
                <p className="hts-sidebar-title">Social Media</p>
                <div className="hts-social-icons">
                  <a href="https://www.youtube.com/@adorIndia" className="hts-social-icon" aria-label="YouTube" target="blank">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2F139191%2Fadmin%2F" className="hts-social-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}